<div class="range-picker">
  <ngx-slider
    *ngIf="maxValue !== undefined; else singleRange"
    [(value)]="value"
    [(highValue)]="maxValue"
    [options]="options"
    [manualRefresh]="manualRefresh"
    (userChange)="changing($event)"
    (userChangeStart)="changeStart($event)"
    (userChangeEnd)="changed($event)"
  ></ngx-slider>
  <ng-template #singleRange>
    <ngx-slider
      [(value)]="value"
      [options]="options"
      [manualRefresh]="manualRefresh"
      (userChange)="changing($event)"
      (userChangeStart)="changeStart($event)"
      (userChangeEnd)="changed($event)"
    ></ngx-slider>
  </ng-template>
</div>
